import React from "react";

const Hero = () => {
    return (
        <div className="hero w-full bg-gray-500 h-56 flex items-center justify-center">
            <h1 className="font-sans text-5xl font-bold text-gray-50">PixaClone</h1>
        </div>
    );
};

export default Hero;
